import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function MentorshipForm({ onSubmit, onCancel, initialData = {}, staffUsers = [], juvenileId }) {
  const [formData, setFormData] = useState({
    mentor_id: '',
    notes: '',
    status: 'Active',
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);

  const isEditing = !!initialData.id;

  useEffect(() => {
    if (isEditing) {
      setFormData({
        mentor_id: initialData.mentor_id || '',
        notes: initialData.notes || '',
        status: initialData.status || 'Active',
      });
      setStartDate(initialData.start_date ? new Date(initialData.start_date) : new Date());
      setEndDate(initialData.end_date ? new Date(initialData.end_date) : null);
    }
  }, [initialData, isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submissionData = {
      ...formData,
      juvenile_id: juvenileId,
      start_date: startDate,
      end_date: endDate,
    };
    onSubmit(submissionData);
  };

  return (
    <div className="card p-6 mt-4 bg-slate-50 border-gold">
      <h3 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'End' : 'Assign New'} Mentorship</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        {isEditing ? (
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">End Date</label>
            <DatePicker selected={endDate} onChange={date => setEndDate(date)} className="w-full" dateFormat="dd/MM/yyyy" required />
          </div>
        ) : (
          <>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Select Mentor</label>
              <select name="mentor_id" value={formData.mentor_id} onChange={handleChange} required>
                <option value="">-- Select a Staff Member --</option>
                {staffUsers.map(user => <option key={user.id} value={user.id}>{user.full_name}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Start Date</label>
              <DatePicker selected={startDate} onChange={date => setStartDate(date)} className="w-full" dateFormat="dd/MM/yyyy" required />
            </div>
          </>
        )}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Notes</label>
          <textarea name="notes" value={formData.notes} onChange={handleChange} />
        </div>
        {isEditing && (
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Status</label>
            <select name="status" value={formData.status} onChange={handleChange}>
              <option value="Active">Active</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
        )}
        <div className="flex justify-end gap-4 pt-4 mt-2 border-t border-slate-200">
          <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
          <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save Assignment</button>
        </div>
      </form>
    </div>
  );
}

export default MentorshipForm;